var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M254.2,176.4c2.5-10.4,9-20.4,12-30.8c2.8-9.9,0.7-20.6,9.4-31.9c11.5-14.8,42.6-19.9,66.1-22.4 c-6.3,0.1-12.6,0.2-18.7,0.5c-16.4,0.9-32.4,2-46.1,11c-15.8,10.4-17.4,20.4-21.2,37c-3.5,15.5-11.1,33.1-10.6,49 c0.5,15.8,6.7,40,11.6,46.2c0.4,0.5,0.8,1,1.2,1.5C259.4,215.6,249.3,196.9,254.2,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M451.6,129.2c-2.9-16-5.5-26.6-22.5-33c-15.9-6-36.1-5.8-52.7-5.2c-11.2,0.3-23.1,0.2-34.7,0.3 c-23.5,2.5-54.7,7.6-66.1,22.4c-8.7,11.3-6.6,22-9.4,31.9c-3,10.4-9.5,20.4-12,30.8c-4.9,20.6,5.3,39.3,3.8,60.1 c3.6,4.7,5.9,10.6,7.5,16.1c1.8-9.4-4.1-23.1,1.3-44.1c1.8-7,7.7-14.1,12.2-19.9c5.7-7.3,5.5-10.6,6.1-19.9 c1.2-19.9,14.4-20.7,31.5-18.1c16.5,2.5,31.8,6.4,49.5,4.2c16.2-2,32-9.5,46.9-7.6c20.7,2.6,16.2,21.5,20.9,37.5 c3.9,13.2,12.4,17.3,15.1,39.9c1.6,13.7,2.9,24.9,2.4,41.4c17-38.1,9-60.1,11.4-93.6C463.9,156.2,454.8,147.1,451.6,129.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle3D);
export default __webpack_public_path__ + "static/media/man_hairstyle_3d.3553f62835221f5cef07d350e5712c10.svg";
export { ForwardRef as ReactComponent };